var map = {
	"./car-ramen.png": 8435,
	"./cat-ah.png": 5949,
	"./cat-eat.jpg": 3770,
	"./cat-see.jpg": 6865,
	"./cat.png": 8551,
	"./fish.png": 1757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9099;